import React, { Component } from 'react';
import { connect } from 'react-redux';

import Page from '../components/Page';

class ContactUs extends Component{

	constructor(props){
		super(props);

		this.state = {};
    }
    
	render(){

		return(
			<Page pageTitle="Contact Us">
				<div className="clearfix">
                    <div className="col-sm-9 card" style={{ minHeight: "20em" }}>
						<h3>Get in touch with us</h3><br/>
						
						<h5>Email &amp; Website:</h5>
						<ul className="infolist">
							<li><a href="mailto:info@tira.go.tz" target="_blank"  rel='noopener noreferrer'>info@tira.go.tz</a></li>
							<li><a href="mailto:support@tiip.co.tz" target="_blank"  rel='noopener noreferrer'>support@tiip.co.tz</a></li>
							<li><a href="mailto:mcharali@tira.go.tz" target="_blank"  rel='noopener noreferrer'>mcharali@tira.go.tz</a></li>
							<li><a href="mailto:amlaki@tira.go.tz" target="_blank"  rel='noopener noreferrer'>amlaki@tira.go.tz</a></li>
							<li><a href="http://www.tira.go.tz" target="_blank"  rel='noopener noreferrer'>www.tira.go.tz</a></li>
						</ul>

						<h5>Phone:</h5>
						<ul className="infolist">
							<li><a href="tel:+255(22) 2132537">+255(22) 2132537</a></li>
							<li><a href="+255(22) 2116120">+255(22) 2116120</a></li>
							<li><a href="+255(22) 2116131">+255(22) 2116131</a></li>
						</ul>
                    </div>
				</div>
			</Page>
		);
	}
}


const mapStateToProps = (state, ownProps) => ({
	user: state.user
});

export default connect(mapStateToProps)(ContactUs);


// WEBPACK FOOTER //
// ./src/pages/ContactUs.jsx